export default "__VITE_ASSET__8d8be20a__"